export const ADD_INGREDIENT='ADD_INGREDIENT';
export const REMOVE_INGREDIENT='REMOVE_INGREDIENT'
export const UPDATE_PURCHASABLE='UPDATE_PURCHASABLE'
export const RESET_INGREDIENTS="RESET_INGREDIENTS"
export const LOAD_ORDERS='LOAD_ORDERS'
export const ORDER_LOAD_FAILED='ORDER_LOAD_FAILED'


export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_LOADING = "AUTH_LOADING";
export const AUTH_LOGOUT = "AUTH_LOGOUT";